import { Zap } from "lucide-react";
import { useLang } from "../context/LangContext";

export default function Marquee() {
  const { t, lang } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-[#E8DFC5] bg-white/60 py-5 overflow-hidden"
      dir="ltr"
    >
      <div className="marquee-track items-center gap-10 px-5">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 shrink-0" dir={lang === "ar" ? "rtl" : "ltr"}>
            <span className="font-heading font-semibold text-lg sm:text-xl text-stone-500 whitespace-nowrap">
              {item}
            </span>
            <Zap className="w-4 h-4 text-emerald-500 shrink-0" fill="currentColor" />
          </span>
        ))}
      </div>
    </div>
  );
}
